<template>
  <b-navbar toggleable="lg" type="dark" variant="primary" sticky>
    <b-container>
      <b-navbar-brand :to="{ name: 'Home' }">
        <img v-if="config && config.images && config.images.logo"
             :src="config.images.logo"
             alt="Logo"
             height="40"
             @error="onLogoError">
        <img v-else
             :src="logoPlaceholder"
             alt="Logo"
             height="40">
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item :to="{ name: 'Home' }">Inicio</b-nav-item>
          <b-nav-item :to="{ name: 'Products' }">Productos</b-nav-item>
          <b-nav-item :to="{ name: 'Categories' }">Categorías</b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-form class="mr-3" @submit.prevent="search">
            <b-input-group>
              <b-form-input 
                v-model="searchQuery" 
                placeholder="Buscar productos..."
                size="sm">
              </b-form-input>
              <b-input-group-append>
                <b-button size="sm" variant="outline-light" type="submit">
                  <b-icon icon="search"></b-icon>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-nav-form>

          <b-nav-item :to="{ name: 'Cart' }" class="position-relative">
            <b-icon icon="cart3" font-scale="1.2"></b-icon>
            <b-badge v-if="cartCount > 0" 
                     variant="danger" 
                     pill 
                     class="position-absolute"
                     style="top: -5px; right: -10px;">
              {{ cartCount }}
            </b-badge>
          </b-nav-item>

          <b-nav-item-dropdown v-if="isAuthenticated" right>
            <template #button-content>
              <b-icon icon="person-circle"></b-icon>
              {{ user.name }}
            </template>
            <b-dropdown-item @click="logout">Cerrar sesión</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item v-else :to="{ name: 'Login' }">
            <b-icon icon="person-circle"></b-icon>
            Ingresar
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-container>
  </b-navbar>
</template>

<script>
export default {
  name: 'NavbarComponent',
  data() {
    return {
      searchQuery: '',
      shopName: 'ESCALITY Shop',
      logoPlaceholder: require('@/assets/images/logo-placeholder.svg')
    }
  },
  computed: {
    config() {
      return this.$store.getters.shopConfig
    },
    cartCount() {
      return this.$store.getters.cartItemCount
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    user() {
      return this.$store.state.user
    }
  },
  methods: {
    search() {
      if (this.searchQuery.trim()) {
        this.$router.push({ 
          name: 'Products', 
          query: { search: this.searchQuery }
        })
      }
    },
    onLogoError(e) {
      e.target.src = this.logoPlaceholder
    },
    logout() {
      this.$store.dispatch('logout')
      this.$router.push({ name: 'Home' })
    }
  }
}
</script>

<style scoped>
.navbar-brand img {
  max-height: 40px;
  width: auto;
}
</style>